/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from 'react';
import ContractorDirectory from "./ContractorDirectory"; // eslint-disable-line no-unused-vars

const ContractorDirectoryContainer = (props) => {
    return(
       <ContractorDirectory/>
    )
};

export default ContractorDirectoryContainer;
